import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  trainerList: []
};

const trainersReducerSlice=createSlice({
  name:"trainers",
  initialState,
  reducers:{
    updateTrainers(state,action){
      return{
        ...state,
        trainerList: [...action.payload]
      } 
    },
    updateTrainer(state,action){
      return{
        ...state,
        trainerList: state.trainerList.map((trainer) => {
          if (trainer._id === action.payload.id) {
            return action.data;
          }
          return trainer;
        })
      }
    }
  }
})


export const trainersReducerAction = trainersReducerSlice.actions
export const trainersReducers = trainersReducerSlice.reducer
